<template>
	<div>
		<div class="content">
			<div class="item">
				<span class="title">流水号</span>
				<span class="value">{{detail.batch_serial_number}}</span>
			</div>
		
			<div class="item">
				<span class="title">备注</span>
				<span class="value">{{detail.describe}}</span>
			</div>
		
			<div class="item">
				<span class="title">交易类型</span>
				<span class="value">
					<span v-if="detail.type==='1'">收入</span>
					<span v-else>支出</span>
				</span>
			</div>
		
			<div class="item">
				<span class="title">金额</span>
				<span class="value">{{detail.amount}}</span>
			</div>
		</div>
	</div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'

export default {
	name: 'balancedetail',
	components: {
		CommonHeader
	},
	
	beforeCreate(){
		sessionStorage.setItem("roleType","customer")
	},
		
	created() {
		this.detail = this.$route.query.data;
	},
    
    mounted(){
       document.title = "余额明细详情"
    },
	
	data() {
		return {
			detail: {}
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';
@import '~@/assets/styles/reset.css';
.content {margin:18px 22px 0 22px;font-size: 14px;font-family:PingFangSC-Medium;font-weight:500;}
.item {display: flex;justify-content: space-between;font-family:PingFangSC-Medium;font-weight:500;margin-bottom: 12px}
.title {color:rgba(155,155,155,1)}
.value {color:rgba(74,74,74,1);}

</style>